import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/LandingPage/LandingPage";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import DemoPage from "./pages/DemoPage/DemoPage";
import HomePage from "./pages/HomePage/HomePage";
import WrongEmailSignin from "./pages/HomePage/WrongEmailSignin";
import ForgotPasswordPage from "./pages/SigninPage/ForgotPasswordPage";
import ForgotPasswordConfirmationPage from "./pages/SigninPage/ForgotPasswordConfirmationPage";
import SigninPage from "./pages/SigninPage/SigninPage";
import SigninConfirmationPage from "./pages/SigninPage/SigninConfirmationPage";
import SignupPage from "./pages/SignupPage/SignupPage";
import AnalysisPage from "./pages/AnalysisPage/AnalysisPage";
import AnalysisHistoryPage from "./pages/AnalysisPage/AnalysisHistoryPage";
import ComPage from "./pages/ComPage/ComPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import PaymentSuccessPage from "./pages/ProfilePage/PaymentSuccessPage";
import PaymentErrorPage from "./pages/ProfilePage/PaymentErrorPage";
import ReducePage from "./pages/ReducePage/ReducePage";
import AnalysisProduceChoice from "./pages/AnalysisPage/AnalysisProduceChoice";
import ReduceScenarios from "./pages/ReducePage/ReduceScenarios";
import ReduceScenarioChoice from "./pages/ReducePage/ReduceScenarioChoice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReduceParametersChoice from "./pages/ReducePage/ReduceParametersChoice";
import ReduceLoadingScreen from "./pages/ReducePage/ReduceLoadingScreen";
import ReduceAnalysis from "./pages/ReducePage/ReduceAnalysis";
import ReportChoice from "./pages/ComPage/ReportChoice";
import ReportPage from "./pages/ComPage/ReportPage";
import EcoKitPage from "./pages/ComPage/EcoKitPage";
import HelpPage from "./pages/HelpPage/HelpPage";
import NotFound from "./pages/NotFound/NotFound";

import { useSelector, useDispatch } from "react-redux";
import { isLoaded, isEmpty } from "react-redux-firebase";
import { useEffect } from "react";
import { useState } from "react";

import { getAuth, onAuthStateChanged } from "firebase/auth";

import { signInWithEmailLink_, clearStore, signOut } from "./redux/actions/authActions";
import { fetchProducts, fetchSubscription, getFreeSubscriptionDaysLeft, setFreeSubscriptionDaysLeft } from "./redux/actions/userActions";
import { fetchUserInfo } from "./redux/actions/userActions";
import ComponentLoading from "./commonComponents/ComponentLoading";

import ReactGA from "react-ga";
// const TRACKING_ID = "G-37PZ8M5E9G"; // OUR_TRACKING_ID
const TRACKING_ID = "UA-243962529-1"; // OUR_TRACKING_ID
if (process.env.REACT_APP_NODE_ENV === "DEV") {
  ReactGA.initialize(TRACKING_ID, { cookieDomain: "none" });
} else {
  ReactGA.initialize(TRACKING_ID);
}

function App() {
  const [isAuthenticated, setIsAuthentificated] = useState(false);
  const dispatch = useDispatch();
  const signInWithEmailLink_rd = (item) => dispatch(signInWithEmailLink_(item));
  const fetchUserInfo_rd = () => dispatch(fetchUserInfo());
  const fetchSubscription_rd = (item) => dispatch(fetchSubscription(item));
  const setFreeSubscriptionDaysLeft_rd = (item) => dispatch(setFreeSubscriptionDaysLeft(item));
  const fetchProducts_rd = () => dispatch(fetchProducts());
  const clearStore_rd = (item) => dispatch(clearStore(item));
  const signOut_rd = (item) => dispatch(signOut(item));
  const subscription = useSelector((state) => (state.user.subscription ? state.user.subscription : null));
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const current_period = useSelector((state) => (state.user.subscription_days_left ? state.user.subscription_days_left : null));

  const [loading, setLoading] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    async function sign_fn() {
      setLoading(true);
      await signInWithEmailLink_rd("");
      setLoading(false);
    }
    if (!auth.currentUser) {
      sign_fn();
    }
  }, [auth]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setLoading(true);
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        console.log("[Authentification ok]");
        setIsAuthentificated(true);
      } else {
        // User is signed out
        setIsAuthentificated(false);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    const fetch_fn = async () => {
      await fetchUserInfo_rd();
      await fetchSubscription_rd({ user_id: auth.currentUser.uid });
      // setFreeSubscriptionDaysLeft_rd(getFreeSubscriptionDaysLeft(user_info && user_info))
      setFreeSubscriptionDaysLeft_rd(20);
    };
    if (isAuthenticated) {
      fetch_fn();
    }
  }, [isAuthenticated]);
  return (
    <div className="bg-[#F3F5F7] absolute top-0 left-0 w-full h-full overflow-auto">
      <ToastContainer />
      {!loading ? (
        <>
          {isAuthenticated ? (
            <>
              {current_period < 0 && !subscription ? (
                <Router>
                  <Routes>
                    <Route path="/Profile" element={<ProfilePage />} />
                    <Route path="/*" element={<ProfilePage />} />
                  </Routes>
                </Router>
              ) : (
                <Router>
                  <Routes>
                    <Route path="/Demo" element={<DemoPage />} />
                    <Route path="/Home" element={<HomePage />} />
                    <Route path="/WrongEmailSignin" element={<WrongEmailSignin />} />
                    <Route path="/" element={<SigninPage />} />
                    <Route path="/ForgotPassword" element={<ForgotPasswordPage />} />
                    <Route path="/ForgotPasswordConfirmationPage" element={<ForgotPasswordConfirmationPage />} />
                    <Route path="/SignUp" element={<SignupPage />} />
                    <Route path="/SigninConfirmation" element={<SigninConfirmationPage />} />
                    <Route path="/AnalysisProduceChoice" element={<AnalysisProduceChoice />} />
                    <Route path="/Analysis" element={<AnalysisPage />} />
                    <Route path="/AnalysisHistory" element={<AnalysisHistoryPage />} />
                    <Route path="/Com" element={<ComPage />} />
                    <Route path="/Profile" element={<ProfilePage />} />
                    <Route path="/PaymentSuccess" element={<PaymentSuccessPage />} />
                    <Route path="/PaymentError" element={<PaymentErrorPage />} />
                    <Route path="/Reduce" element={<ReducePage />} />
                    <Route path="/ReduceScenarios" element={<ReduceScenarios />} />
                    <Route path="/ReduceScenarioChoice" element={<ReduceScenarioChoice />} />
                    <Route path="/ReduceParametersChoice" element={<ReduceParametersChoice />} />
                    <Route path="/ReduceLoadingScreen" element={<ReduceLoadingScreen />} />
                    <Route path="/ReduceAnalysis" element={<ReduceAnalysis />} />
                    <Route path="/ReportChoice" element={<ReportChoice />} />
                    <Route path="/Report" element={<ReportPage />} />
                    <Route path="/EcoKit" element={<EcoKitPage />} />
                    <Route path="/Help" element={<HelpPage />} />
                    <Route path="/*" element={<NotFound />} />
                  </Routes>
                </Router>
              )}
            </>
          ) : (
            <Router>
              <Routes>
                <Route path="/" element={<SigninPage />} />
                <Route path="/SigninConfirmation" element={<SigninConfirmationPage />} />
                <Route path="/WrongEmailSignin" element={<WrongEmailSignin />} />
                <Route path="/ForgotPassword" element={<ForgotPasswordPage />} />
                <Route path="/ForgotPasswordConfirmationPage" element={<ForgotPasswordConfirmationPage />} />
              </Routes>
            </Router>
          )}
        </>
      ) : (
        <>
          <ComponentLoading height={35} style={"h-full flex items-center justify-center"} />
        </>
      )}
    </div>
  );
}

export default App;
